import { combineReducers } from "redux";
import auth from './auth';
import performances from './performances';
import route from './route'

export default combineReducers({ auth, performances, route });
